<template>
	<v-container fluid class="mb-4">
		<v-toolbar text dark color="secondary">
			<v-toolbar-title>Informações</v-toolbar-title>
		</v-toolbar>

		<v-form ref="form" v-model="IsFormValid">
			<v-container>
				<v-sheet elevation="2" class="pa-4">
					<v-container>
						<v-row>
							<v-col>
								<v-switch
									v-model="DadosIntervencao.transferido"
									label="Aluno transferido?"
									inset>
								</v-switch>
							</v-col>
						</v-row>
						<v-row>
							<v-col v-if="isAdmin">
								<v-switch
									v-model="DadosIntervencao.nee"
									label="Aluno com NEE?"
									inset>
								</v-switch>
							</v-col>

							<v-col>
								<v-switch
									v-model="DadosIntervencao.feo"
									label="Aluno fora da escolaridade obrigatória?"
									inset
									:disabled="!isAdmin">
								</v-switch>
							</v-col>
						</v-row>
					</v-container>

					<v-container>
						<v-row>
							<v-col>
								<v-select
									v-model="DadosIntervencao.medida_apoio"
									:items="NaoSim"
									label="O aluno está integrado nalguma medida de apoio?"
									:rules="[InputRules.requiredBoolean]"
									@change="changeMedidaApoio">
								</v-select>
							</v-col>

							<v-col>
								<!-- TODO: check required -->
								<v-select
									v-model="DadosIntervencao.medida_apoio_tipo"
									:items="TiposMedidasApoio"
									label="De que tipo?"
									v-show="DadosIntervencao.medida_apoio"
									:disabled="!DadosIntervencao.medida_apoio">
								</v-select>
							</v-col>
						</v-row>
					</v-container>

					<v-container>
						<v-textarea v-model="DadosIntervencao.observacoes"
							label="Observações / notas"
							clearable counter="2000"
							hint="Indique informação relevante sobre / para a intervenção com este aluno."
							:rules="[InputRules.maxChars]">
						</v-textarea>
					</v-container>

					<div class="my-8">
						<v-layout d-flex justify-end>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn text color="primary" v-on="on" :disabled="!IsFormValid" @click="saveDadosIntervencao">
										<v-icon left>save</v-icon>
										Gravar
									</v-btn>
								</template>
								<span>Gravar observações</span>
							</v-tooltip>
						</v-layout>

						<p class="text-end red--text" v-show="!IsFormValid">Existem erros de validação.</p>
					</div>
				</v-sheet>
			</v-container>
		</v-form>

		<v-divider></v-divider>

        <v-btn color="primary" text class="my-8" @click="goBack()">
            <v-icon left>arrow_back</v-icon>
            Voltar
        </v-btn>

		<Loading :isLoading="isLoading" />

		<v-snackbar v-model="Snackbar.show" bottom right vertical :timeout="5000">
			{{ Snackbar.message }}
			<v-btn text @click="Snackbar.show = false">Fechar</v-btn>
		</v-snackbar>

		<ErrorDialog :show-dialog="this.errorMessage.show" :error-message="this.errorMessage"></ErrorDialog>
	</v-container>
</template>

<script>
    import Vue from 'vue'
	import StaticData from '@/data/static-data.js';
	Vue.use(StaticData);

	import UserService from '@/services/user.service';
	const userService = new UserService();

	import Loading from "@/components/Loading";

	import ErrorDialog from '@/components/ErrorDialog';

    export default {
		components: {
			Loading,
			ErrorDialog
		},

        data: () => ({
			isLoading: false,
			errorMessage: {
				show: false
			},
			IsFormValid: true,
			NaoSim: StaticData.NaoSim,
			TiposMedidasApoio: StaticData.TiposMedidasApoio,
			DadosIntervencao: {
				medida_apoio: null,
				medida_apoio_tipo: null,
				observacoes: null
			},
            InputRules: {
                requiredBoolean: value => value != null || 'Campo obrigatório',
                maxChars: value => !value || value.length <= 2000 || 'Deverá conter no máximo 2000 caracteres'
			},
			Snackbar: {
				show: false,
				message: 'Informação registada com sucesso.'
			},
        }),

        created () {
			this.alunoId = this.$route.params.alunoId;
			this.loadDadosIntervencao();
        },

        computed: {
			isAdmin () {
				return userService.isAdmin();
			}
        },

        methods: {
			loadDadosIntervencao () {
				this.isLoading = true;

				this.$http.get(process.env.VUE_APP_API_ROOT + `/aluno-informacoes?aluno=${this.alunoId}`).then(function(data){
                    return data.json();
                }).then(function(data){
					console.log("data", data);
					
					if (data && data.length == 1) {
						this.DadosIntervencao = data[0];
					}

					this.isLoading = false;
                }, response => { // error callback
					this.isLoading = false;
				});
			},
			changeMedidaApoio() {
				if (!this.DadosIntervencao.medida_apoio) {
					this.DadosIntervencao.medida_apoio_tipo = null;
				}
			},
			saveDadosIntervencao () {
				this.isLoading = true;

				console.log("DadosIntervencao", this.DadosIntervencao);
				if (this.DadosIntervencao.id) {
					this.$http.put(process.env.VUE_APP_API_ROOT + `/aluno-informacoes/${this.DadosIntervencao.id}/`, this.DadosIntervencao).then(function(data){
						console.log(data);

						this.Snackbar.show = true;

						this.isLoading = false;
					}, response => { // error callback
						console.log(response);

						this.errorMessage.message = "Ocorreu um erro ao editar ao gravar os dados.";
						this.errorMessage.show = true;

					this.isLoading = false;
					});
				}
				else {
					this.DadosIntervencao.aluno = this.alunoId;

					this.$http.post(process.env.VUE_APP_API_ROOT + '/aluno-informacoes/', this.DadosIntervencao).then(function(data){
						console.log(data);

						this.DadosIntervencao = data.body;

						this.Snackbar.show = true;
						// console.log("DadosIntervencao", this.DadosIntervencao);

						this.isLoading = false;
					}, response => { // error callback
						console.log(response);

						this.errorMessage.message = "Ocorreu um erro ao editar ao gravar os dados.";
						this.errorMessage.show = true;

						this.isLoading = false;
					});
                }
			},
			goBack () {
                window.history.length > 1
                    ? this.$router.go(-1)
                    : this.$router.push('/')
            }
        },
    }
</script>